<template>
  <div class="w-full py-5 overflow-hidden">
    <div class="relative flex items-center">
      <div class="flex animate-logo-marquee" :style="{ minWidth: '200%' }">
        <div
          class="flex items-center justify-center px-4"
          v-for="(logo, index) in duplicatedItems"
          :key="index"
        >
          <img
            :src="`${logo.sourceUrl}`"
            :alt="logo.title"
            class="max-h-[60px] max-w-[120px] object-contain"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    required: true
  }
});

// Duplicate for seamless infinite scroll
const duplicatedItems = computed(() => [...props.items, ...props.items,...props.items]);
</script>

<style scoped>
@keyframes logo-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.animate-logo-marquee {
  animation: logo-marquee 20s linear infinite;
  will-change: transform;
}
</style>